<script>
export default { inheritAttrs: false };
</script>

<script setup>

/*==================================================================*/
/*================== IMPORTS =======================================*/
/*==================================================================*/

import ChipBase from '@/components/v2/base/ChipBase/ChipBase.vue';
import useColaboradorStore from '@/api/v2/stores/ColaboradorStore.js';

/*==================================================================*/
/*================== STORES ========================================*/
/*==================================================================*/

const colaboradorStore = useColaboradorStore();

</script>

<template>

    <ChipBase
        icon="mdi-account-circle-outline"
        v-bind="$attrs"
    >
        {{ `Usuario: ${colaboradorStore?.colaborador?.nome ?? ''}` }}
    </ChipBase>

</template>

<style scoped>
</style>
